import React from 'react';
import IconButton from './IconButton';

const RowDeleteButton = ({
  dataPosition = 'bottom right',
  disabled,
  entity,
  floated,
  iconName = 'minus',
  onClick,
}) => (
  <IconButton
    basic
    className="aridhia-row-delete-button"
    compact
    dataPosition={dataPosition}
    disabled={disabled}
    floated={floated}
    icon
    iconClassName="primary"
    iconName={iconName}
    iconOnly
    messageId={`actions.delete.${entity}.row`}
    onClick={onClick}
  />
);

export default RowDeleteButton;
